module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_pro_certification-9323aab47380c53428488484dc48751e.svg";